var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPayout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5312_12678)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7163 18.5743L21.0457 17.1367C21.5756 16.9795 22.1411 16.989 22.6654 17.1638C23.1898 17.3386 23.6479 17.6703 23.9775 18.114C12.0263 24.0881 15.8934 24.0529 5.40914 20.5572L1.5 23.0004",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2956 19.0918H15.6706C15.8136 19.1174 15.9604 19.1114 16.1008 19.0742C16.2412 19.0369 16.3717 18.9693 16.4832 18.8761C16.5946 18.7829 16.6842 18.6664 16.7457 18.5348C16.8072 18.4032 16.8391 18.2597 16.8391 18.1145C16.8391 17.9692 16.8072 17.8257 16.7457 17.6941C16.6842 17.5625 16.5946 17.446 16.4832 17.3528C16.3717 17.2596 16.2412 17.192 16.1008 17.1548C15.9604 17.1175 15.8136 17.1115 15.6706 17.1372H12.7388C11.5804 15.942 10.0044 15.2416 8.34099 15.1826H5.40914L1.5 17.1372",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1533 7.50932C10.1533 8.29847 10.3088 9.0799 10.6108 9.80898C10.9127 10.5381 11.3554 11.2005 11.9134 11.7585C12.4714 12.3166 13.1339 12.7592 13.863 13.0612C14.5921 13.3632 15.3735 13.5186 16.1626 13.5186C16.9518 13.5186 17.7332 13.3632 18.4623 13.0612C19.1914 12.7592 19.8539 12.3166 20.4119 11.7585C20.9699 11.2005 21.4125 10.5381 21.7145 9.80898C22.0165 9.0799 22.172 8.29847 22.172 7.50932C22.172 6.72016 22.0165 5.93874 21.7145 5.20965C21.4125 4.48057 20.9699 3.81811 20.4119 3.26009C19.8539 2.70207 19.1914 2.25943 18.4623 1.95743C17.7332 1.65544 16.9518 1.5 16.1626 1.5C15.3735 1.5 14.5921 1.65544 13.863 1.95743C13.1339 2.25943 12.4714 2.70207 11.9134 3.26009C11.3554 3.81811 10.9127 4.48057 10.6108 5.20965C10.3088 5.93874 10.1533 6.72016 10.1533 7.50932V7.50932Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1631 4.43236V3.45508",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6255 4.43164H15.6426C15.3381 4.43185 15.0432 4.53801 14.8084 4.73189C14.5736 4.92578 14.4136 5.19532 14.3559 5.49428C14.2981 5.79324 14.3461 6.10299 14.4917 6.3704C14.6374 6.63781 14.8715 6.84621 15.154 6.95987L17.1711 7.76711C17.4536 7.88077 17.6877 8.08918 17.8333 8.35659C17.979 8.624 18.027 8.93375 17.9692 9.23271C17.9114 9.53166 17.7514 9.8012 17.5167 9.99509C17.2819 10.189 16.987 10.2951 16.6825 10.2953H14.6937",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1631 11.2732V10.2959",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5312_12678"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayout);
export default __webpack_public_path__ + "static/media/Payout.93f803ba99430fd9369d06a69ecc6eff.svg";
export { ForwardRef as ReactComponent };